"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _app = require("@package/app");

var _numeral = _interopRequireDefault(require("@package/numeral"));

var _dicts = require("@package/dicts");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Success(_ref) {
  var accounts = _ref.accounts,
      amounts = _ref.amounts,
      hasCommissions = _ref.hasCommissions;

  try {
    var calculateAccount = function calculateAccount(account) {
      return account.reduce(function (result, current) {
        return [result[0] + current['amount'], result[1] + current['amountWithCommission'], current['currency']];
      }, [0, 0, '']);
    };

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary-headline']
    }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u044B"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary-holder']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary-amount']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['checking__summary-amount-label']
    }, "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0439 \u0431\u0430\u043B\u0430\u043D\u0441"), accounts.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: index,
        className: (0, _classnames["default"])(_defaultModule["default"]['checking__summary-amount-value'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['rub'], item['currency'] === 'RUB'))
      }, (0, _numeral["default"])(item['balance']).format(), " ", _dicts.CURRENCY_SYMBOLS[item['currency']]);
    })), !hasCommissions && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary-amount']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['checking__summary-amount-label']
    }, "\u0411\u0443\u0434\u0435\u0442 \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E"), amounts.map(function (amount, index) {
      var fullAmount = calculateAccount(amount);
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: index,
        className: (0, _classnames["default"])(_defaultModule["default"]['checking__summary-amount-value'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['rub'], fullAmount[2] === 'RUB'))
      }, (0, _numeral["default"])(fullAmount[0]).format(), " ", _dicts.CURRENCY_SYMBOLS[fullAmount[2]]);
    })), hasCommissions && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary-amount']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['checking__summary-amount-label']
    }, "\u0411\u0443\u0434\u0435\u0442 \u0441\u043F\u0438\u0441\u0430\u043D\u043E"), amounts.map(function (amount, index) {
      var fullAmount = calculateAccount(amount);
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: index,
        className: (0, _classnames["default"])(_defaultModule["default"]['checking__summary-amount-value'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['rub'], fullAmount[2] === 'RUB'))
      }, (0, _numeral["default"])(fullAmount[1]).format(), " ", _dicts.CURRENCY_SYMBOLS[fullAmount[2]]);
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['checking__summary-amount']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['checking__summary-amount-label']
    }, "\u0411\u0443\u0434\u0435\u0442 \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E"), amounts.map(function (amount, index) {
      var fullAmount = calculateAccount(amount);
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: index,
        className: (0, _classnames["default"])(_defaultModule["default"]['checking__summary-amount-value'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['rub'], fullAmount[2] === 'RUB'))
      }, (0, _numeral["default"])(fullAmount[0]).format(), " ", _dicts.CURRENCY_SYMBOLS[fullAmount[2]]);
    })))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Success;
exports["default"] = _default;